import { name } from 'dayjs/locale/zh-cn';
import Vue, { KeepAlive } from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  //登录页
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/login.vue'),
  },
  //中转页
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import('../views/Transfer.vue'),
  },
  //陪练端
  {
    path: '/teacher',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/teacher/teachPlan',
        name: 'teachPlan',
        component: () => import('../views/teacher/teaPlan/index.vue'),
        children: [
          {
            path: '/teacher/teachPlan/plan',
            name: 'teachPlan',
            component: () => import('../views/teacher/teaPlan/teachPlan.vue'),
          },
          {
            path: '/teacher/teachPlan/reportList',
            name: 'teachReportList',
            component: () => import('@/views/teacher/teaPlan/teachReportList.vue'),
          },
          {
            path: '/teacher/teachPlan/otherReport',
            name: 'teachOtherReport',
            component: () => import('@/views/student/stuTestReport/stuOtherReport.vue'),
          },
          {
            path: '/teacher/teachPlan/trialReport',
            name: 'teachTrialReport',
            component: () => import('@/views/student/stuTestReport/stuTrialReport.vue'),
          },
          {
            path:'/teacher/teachPlan/prepareLessons',
            name:'prepareLessons',
            component:()=>import('@/views/teacher/teaPlan/prepareLessons.vue'),
          },
          {
            path:'/teacher/teachPlan/prepareLessonsTrial',
            name:'prepareLessonsTrial',
            component:()=>import('@/views/teacher/teaPlan/prepareLessonsTrial.vue'),
          },
          {
            path:'/teacher/teachPlan/prepareLessonsTrialQuestion',
            name:'prepareLessonsTrialQuestion',
            component:()=>import('@/views/teacher/teaPlan/prepareLessonsTrialQuestion.vue'),
          },
          {
            path:'/teacher/teachPlan/classDataList',
            name:'prepareLessons',
            component:()=>import('@/views/teacher/teaPlan/classDataList.vue'),
          },
          {
            path:'/teacher/teachPlan/classDataDetail',
            name:'prepareLessons',
            component:()=>import('@/views/teacher/teaPlan/classDataDetail.vue'),
          },
          // 课后作业
          {
            path: '/teacher/teachPlan/lookHomework',
            name: 'lookHomework',
            component: () => import('@/views/teacher/lookHomeWork.vue'),
          },
          // 全部计划
           {
            path: '/teacher/teachPlan/teachAllPlan',
            name: 'teachAllPlan',
            component: () => import('@/views/teacher/teaPlan/teachAllPlan.vue'),
          }

        ],
        // meta: { keepAlive: true } // 需要缓存的页面

      },
      {
        path: '/teacher/coursewareLibrary',
        name: 'coursewareLibrary',
        component: () => import('../views/teacher/coursewareLibrary.vue'),
      },
      {
        path: '/teacher/homework',
        name: 'homework',
        component: () => import('../views/teacher/homework.vue'),
      },
      {
        path: '/teacher/teachNotes',
        component: () => import('../views/teacher/mineNotes/index.vue'),
        children: [
          {
            path: '/teacher/teachNotes/list',
            name: 'teachNotes',
            component: () => import('@/views/teacher/mineNotes/notesList.vue'),
          },
          {
            path: '/teacher/teachNotes/detail',
            name: 'notesDetail',
            component: () => import('@/views/teacher/mineNotes/notesDetail.vue'),
          },
        ]  
      },
      {
        path: '/teacher/teaFeedback',
        name: 'teaFeedback',
        component: () => import('../views/teacher/teaFeedback.vue'),
      },
      // 陪练消息中心
      {
        path: '/teacher/teacherNotifica',
        name: 'teacherNotifica',
        component: () => import('../views/teacher/teacherNotifica.vue'),
      },
    ]
  },
  //上课
  {
    path: '/attendClass',
    component: () => import('../views/attendClass/room.vue'),
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('../views/personalCenter.vue'),
        meta: { keepAlive: true } 
      }
    ]
  },
  //用户端登录
  {
    path: '/stuLogin',
    name: 'stuLogin',
    component: () => import('@/views/student/stuLogin.vue'),
  },
  //用户端完善信息
  {
    path: '/stuInfo',
    name: 'stuInfo',
    component: () => import('@/views/student/stuInfo.vue'),
  },
  //用户端工作台首页
  {
    path: '/stuHome',
    name: 'stuHome',
    component: () => import('@/views/student/stuHome.vue'),
  },
  //用户端全部学习计划
  {
    path: '/stuPlan',
    name: 'stuPlan',
    component: () => import('@/views/student/stuPlan.vue'),
  },
  //用户端报告列表
  {
    path: '/stuReportList',
    name: 'stuReportList',
    component: () => import('@/views/student/stuTestReport/stuReportList.vue'),
  },
  //用户端个人信息完善
  {
    path: '/stuPersonalCenter',
    name: 'stuPersonalCenter',
    component: () => import('@/views/student/stuPersonalCenter.vue'),
  },
  //用户端上课页
  {
    path: '/stuRoom',
    name: 'stuRoom',
    component: () => import('@/views/attendClass/stuRoom.vue'),
  },
  //用户初评
  {
    path: '/stuFirstTest',
    name: 'stuFirstTest',
    component: () => import('@/views/student/stuFirstTest.vue'),
  },
  //用户入门
  {
    path: '/stuDoorTest',
    name: 'stuDoorTest',
    component: () => import('@/views/student/stuDoorTest.vue'),
  },
  {
    path:'/stuTrialReport',
    name:'stuTrialReport',
    component:()=>import('../views/student/stuTestReport/stuTrialReport.vue'),
    // meta: { keepAlive: true } // 需要缓存的页面
  },
  {
    path:'/planDetail',
    name:'planDetail',
    component:()=>import('../views/student/planDetail.vue'),
  },
  {
    path:'/planDetailContent',
    name:'planDetailContent',
    component:()=>import('../views/student/planDetailContent.vue'),
  },
  {
    path:'/stuOtherReport',
    name:'stuOtherReport',
    component:()=>import('../views/student/stuTestReport/stuOtherReport.vue'),
    // meta: { keepAlive: true } // 需要缓存的页面
  },
  // 导出pdf报告
  {
    path:'/exportPdf',
    name:'exportPdf',
    component:()=>import('../views/exportPdf/index.vue'),
  },
  // 学生查看作业
  {
    path:'/stuHomework',
    name:'stuHomework',
    component:()=>import('@/views/student/stuHomework/stuHomework.vue'),
  },
  // 学生查看作业
  {
    path:'/stuHomeworkList',
    name:'stuHomeworkList',
    component:()=>import('@/views/student/stuHomework/stuHomeworkList.vue'),
  },
  // 学生学情报告
  {
    path:'/stuLearnReport',
    name:'stuLearnReport',
    component:()=>import('@/views/student/stuLearnReport/learnReport.vue'),
  },
  // 学生学情报告阶段详情
  {
    path:'/stuStageDetail',
    name:'stuStageDetail',
    component:()=>import('@/views/student/stuLearnReport/stageDetail.vue'),
  },
  // 学生学情报告题目列表
  {
    path:'/stuQuestionList',
    name:'stuQuestionList',
    component:()=>import('@/views/student/stuLearnReport/questionList.vue'),
  },
  // 学生学情报告题目详情
  {
    path:'/stuQuestionDetail',
    name:'stuQuestionDetail',
    component:()=>import('@/views/student/stuLearnReport/questionDetail.vue'),
  },
  // 学生课堂资料列表
  {
    path:'/stuClassDataList',
    name:'stuClassDataList',
    component:()=>import('@/views/student/stuClassData/classDataList.vue'),
  },
  // 学生课堂资料详情
  {
    path:'/stuClassDataDetail',
    name:'stuClassDataDetail',
    component:()=>import('@/views/student/stuClassData/classDataDetail.vue'),
  },
  // 学生消息中心
  {
    path: '/studentNotifica',
    name: 'studentNotifica',
    component: () => import('../views/student/studentNotifica.vue'),
  },
  // 学生设置页面
  {
    path: '/studentSetting',
    name: 'studentSetting',
    component: () => import('../views/student/stuSetting.vue'),
  },
   // 学生知识点树
  {
    path: '/stuKnowledgeTree',
    name: 'stuKnowledgeTree',
    component: () => import('../views/student/stuKnowledgeTree.vue'),
  },
  // 学生反馈意见
  {
    path: '/stuFeedback',
    name: 'stuFeedback',
    component: () => import('@/views/student/stuFeedback.vue'),
  },
   // 陪练端注册页
  {
    path: '/teaRegister',
    name: 'teaRegister',
    component: () => import('@/views/teacher/teaRegister.vue'),
  },
  // 学生端注册页
  {
    path: '/stuRegister',
    name: 'stuRegister',
    component: () => import('@/views/student/stuRegister.vue'),
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/error/404.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

// 判断是否登录
// 登录白名单
const whiteList = ['/', '/transfer']
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  const domain = window.location.hostname
  if (domain.includes('app.shutuobang.cn') || domain.includes('math-app.hxzx.cc')) {
    // 如果不是已经在/stuLogin页面，则跳转到/stuLogin
    if (to.path === '/') {
      next({ path: '/stuLogin' })
    } else {
      next() // 已经在/stuLogin，继续
    }
  } else {
    next() // 域名不匹配，正常访问
  }
  // if (!userInfo) {
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next();
  //   } else {
  //     next('/');
  //   }
  // }
  //next();
});

export default router;
